export default "__VITE_ASSET__d_qe3Mb5__"